/**
 * 共通定数
 *
 * @author hayakawa 2025.04.23
 */

// インポート
import { stopResize, stopDragg, stopResizeHelp, stopDraggHelp } from './Shift/_functions';

// 定数
export const auto_show_time = 0;                                    // 自動表示までのミリ秒
export const auto_hide_time = 3000;                                 // 自動非表示までのミリ秒

export const z_idx_top = 1050;                                      // モーダル表示用
export const z_idx_back = 1030;                                     // モーダル隠し用

export const group_list_inner_height = 350;                         // 店舗グループモーダルで使用する高さ
export const organization_list_inner_height = 275;                  // 店舗グループモーダルで使用する高さ

export const move_no_master = 1;                                    // マスタ
export const move_no_setting = 2;                                   // 設定
export const move_no_predict = 3;                                   // 予測
export const move_no_shift = 4;                                     // シフト
export const move_no_expenses = 5;                                  // 日計表
export const move_no_work = 6;                                      // 労務管理表
export const move_no_logout = 7;                                    // ログアウト
export const move_no_company = 101;                                 // 企業
export const move_no_organization = 102;                            // 店舗
export const move_no_employee = 103;                                // 従業員
export const move_no_company_back = 111;                            // 戻る（企業）
export const move_no_organization_back = 112;                       // 戻る（店舗）
export const move_no_employee_back = 113;                           // 戻る（従業員）
export const move_no_default_shift = 201;                           // 出勤時間
export const move_no_setting_other = 202;                           // その他
export const move_no_group_message = 203;                           // メッセージ
export const move_no_setting_change_company = 211;                  // 設定（企業変更）
export const move_no_setting_change_organization = 212;             // 設定（店舗変更）
export const move_no_predict_index = 301;                           // 予測
export const move_no_predict_change_company = 311;                  // 予測（企業変更）
export const move_no_predict_change_organization = 312;             // 予測（店舗変更）
export const move_no_predict_change_ym = 313;                       // 予測（年月変更）
export const move_no_monthly = 401;                                 // 月次
export const move_no_weekly = 402;                                  // 週次
export const move_no_dayly = 403;                                   // 日次
export const move_no_help = 404;                                    // ヘルプ
export const move_no_job = 405;                                     // ジョブ
export const move_no_dayly_change_company = 411;                    // 日次（企業変更）
export const move_no_dayly_change_organization = 412;               // 日次（店舗変更）
export const move_no_dayly_change_ymd = 413;                        // 日次（年月日変更）
export const move_no_dayly_change_type = 414;                       // 日次（表示タイプ変更）
export const move_no_expenses_index = 501;                          // 日計表
export const move_no_work_index = 601;                              // 労務管理表

export const employee_auth_id_admin = 1;                            // 管理者
export const employee_auth_id_sv = 2;                               // SV
export const employee_auth_id_owner = 3;                            // オーナー
export const employee_auth_id_manager = 4;                          // 店長
export const employee_auth_id_sub_manager = 5;                      // 副店長
export const employee_auth_id_pjcrew = 6;                           // PJクルー
export const employee_auth_id_crew = 7;                             // クルー
export const employee_auth_id_linkage = 8;                          // 情報連携用

export const auth_sdweb_code_pjcrew = 180;                          // PJクルー
export const auth_sdweb_code_crew = 20;                             // クルー

export const employee_work_type_manager = 1;                        // 社員（店長・副店長）
export const employee_work_type_general = 2;                        // 社員（レギュラーキャリア）
export const employee_work_type_part = 3;                           // アルバイト

export const setting_period_type_weekly = 1;                        // 期間：毎週
export const setting_period_type_biweekly = 2;                      // 期間：隔週
export const setting_period_type_twice_a_month = 3;                 // 期間：月に2回
export const setting_period_type_monthly = 4;                       // 期間：月ごとに

export const view_mode_usage_flag_on = 1;                           // 閲覧モード利用フラグ：On
export const view_mode_usage_flag_off = 0;                          // 閲覧モード利用フラグ：Off

export const view_type_organization = 1;                            // 表示タイプ：予定（店舗）
export const view_type_employee = 2;                                // 表示タイプ：希望（従業員）

export const work_plan_type_unsettled = 0;                          // 勤務予定時間ステータス：未確定
export const work_plan_type_confirmed = 1;                          // 勤務予定時間ステータス：確定
export const work_plan_type_requested = 3;                          // 勤務予定時間ステータス：変更依頼

export const shift_type_nothing = 0;                                // シフトタイプ：なし
export const shift_type_normal = 1;                                 // シフトタイプ：通常
export const shift_type_offday = 2;                                 // シフトタイプ：休み
export const shift_type_free = 3;                                   // シフトタイプ：フリー
export const shift_type_clear = 9;                                  // シフトタイプ：クリア

export const work_type_delivery_bike = '1';                         // 職種：デリバリー（バイク）
export const work_type_delivery_car = '10';                         // 職種：デリバリー（車）
export const work_type_delivery_bicycle = '11';                     // 職種：デリバリー（自転車）
export const work_type_make = '2';                                  // 職種：メイク
export const work_type_break = '6';                                 // 職種：休憩
export const work_type_offday = '101';                              // 職種：休み
export const work_type_free = '102';                                // 職種：フリー

export const setting_kind_work_type = 1  ;                          // ヘルプ設定：職種

export const max_employee_organization_group = 10;                  // 店舗グループ最大数

export const $spinner = '<i class="fas fa-spinner fa-spin"></i>';   // スピナー

// デイトタイムピッカーオプション（年月日）
export const option_dtpk = {
    format: 'YYYY/MM/DD',
    icons: {
        time: 'far fa-clock'
    },
    viewMode: 'days',
    locale: 'ja',
    dayViewHeaderFormat: 'YYYY年MM月',
    useCurrent: false,
    defaultDate: false
};

// デイトタイムピッカーオプション（年月日）
export const option_dtpk_with_position = {
    format: 'YYYY/MM/DD',
    icons: {
        time: 'far fa-clock'
    },
    viewMode: 'days',
    locale: 'ja',
    dayViewHeaderFormat: 'YYYY年MM月',
    useCurrent: false,
    defaultDate: false,
    widgetPositioning: {
        horizontal: "auto",
        vertical: "bottom"
    }
};

// デイトタイムピッカーオプション（年月日）日次用
export const option_dtpk_format_hyphen = {
    format: 'YYYY-MM-DD',
    icons: {
        time: 'far fa-clock'
    },
    viewMode: 'days',
    locale: 'ja',
    dayViewHeaderFormat: 'YYYY年MM月',
    useCurrent: false,
    defaultDate: false,
    widgetPositioning: {
        horizontal: 'auto',
        vertical: 'auto'
    },
};

// デイトタイムピッカーオプション（年月）
export const option_dtpk_ym = {
    format: 'YYYY/MM',
    icons: {
        time: 'far fa-clock'
    },
    viewMode: 'months',
    locale: 'ja',
    dayViewHeaderFormat: 'YYYY年',
    useCurrent: false,
    defaultDate: false,
};

// リサイザブルオプション
export const option_resizable = {
    handles: 'e, w',
    minWidth: 1,
    containment: 'parent',
    start: function(e, ui) {
        $(e.target).css('z-index', 20).css('opacity', 0.5);
    },
    stop: function(e, ui) {
        stopResize(e, ui);
    },
};

// リサイザブルオプション
export const option_resizable_help = {
    handles: 'e, w',
    minWidth: 1,
    containment: 'parent',
    start: function(e, ui) {
        $(e.target).css('z-index', 20).css('opacity', 0.5);
    },
    stop: function(e, ui) {
        stopResizeHelp(e, ui);
    },
};

// ドラッガブルオプション
export const option_draggable = {
    opacity: 0.5,
    containment: 'parent',
    grid: [$('.table-dayly').find('.base-width').outerWidth() / 2, 0],
    zIndex: 20,
    start: function(e, ui) {
    },
    stop: function(e, ui) {
        stopDragg(e, ui);
    },
};

// ドラッガブルオプション
export const option_draggable_help = {
    opacity: 0.5,
    containment: 'parent',
    grid: [$('.table-dayly').find('.base-width').outerWidth() / 2, 0],
    zIndex: 20,
    start: function(e, ui) {
    },
    stop: function(e, ui) {
        stopDraggHelp(e, ui);
    },
};

// リンクID
export const LINK_IDS = new Map([
    // メインメニュー
    ['main-menu-master', move_no_master],
    ['main-menu-setting', move_no_setting],
    ['main-menu-predict', move_no_predict],
    ['main-menu-shift', move_no_shift],
    ['main-menu-expenses', move_no_expenses],
    ['main-menu-work', move_no_work],
    // サブメニュー
    ['sub-menu-master', move_no_master],
    ['sub-menu-setting', move_no_setting],
    ['sub-menu-predict', move_no_predict],
    ['sub-menu-shift', move_no_shift],
    ['sub-menu-expenses', move_no_expenses],
    ['sub-menu-work', move_no_work],
    // ヘッダーニュー
    ['header-menu-master', move_no_master],
    ['header-menu-setting', move_no_setting],
    ['header-menu-predict', move_no_predict],
    ['header-menu-shift', move_no_shift],
    ['header-menu-expenses', move_no_expenses],
    ['header-menu-work', move_no_work],
    ['header-menu-logout', move_no_logout],
    // マスタメニュー
    ['master-menu-company', move_no_company],
    ['master-menu-organization', move_no_organization],
    ['master-menu-employee', move_no_employee],
    // 企業追加/修正
    ['return-compamy-list', move_no_company_back],
    // 店舗追加/修正
    ['return-organization-list', move_no_organization_back],
    // 従業員追加/修正
    ['return-employee-list', move_no_employee_back],
    // 設定メニュー
    ['setting-menu-default', move_no_default_shift],
    ['setting-menu-others', move_no_setting_other],
    ['setting-menu-message', move_no_group_message],
    // 予測メニュー
    ['predict-menu-index', move_no_predict_index],
    // シフトメニュー
    ['shift-menu-monthry', move_no_monthly],
    ['shift-menu-weekly', move_no_weekly],
    ['shift-menu-dayly', move_no_dayly],
    ['shift-menu-help', move_no_help],
    ['shift-menu-job', move_no_job],
    // 日計表メニュー
    ['expenses-menu-index', move_no_expenses_index],
    // 労務メニュー
    ['work-menu-index', move_no_work_index],
]);

// 警告メッセージ
export const alert_messages = [
    { key: "is_full_worked", val: "・最低でも週1日は休みを取ってください。\n" },
    { key: "is_over_time_w16_m80", val: "・残業は長くても週16時間、月80時間未満に設定してください。\n" },
    { key: "is_over_time_m25", val: "・残業は長くても週5時間、月25時間未満に設定してください。\n" },
    { key: "is_over_time_m45_1", val: "・45時間以上の残業1回目です。\n" },
    { key: "is_over_time_m45_2", val: "・45時間以上の残業2回目です。\n" },
    { key: "is_over_time_m45_3", val: "・45時間以上の残業3回目です。\n" },
    { key: "is_over_time_m45_4", val: "・45時間以上の残業4回目です。\n" },
    { key: "is_over_time_m45_5", val: "・45時間以上の残業5回目です。\n" },
    { key: "is_over_time_m45_6", val: "・来月以降45時間以上の残業はできません。\n" },
    { key: "is_over_time_m45_7", val: "・45時間以上の残業はできません。\n" },
    { key: "is_to_time_21", val: "・18歳未満は21時まで勤務にしましょう。\n" },
    { key: "is_to_time_22", val: "・18歳未満は22時以降の勤務はできません。\n" },
    { key: "is_over_time", val: "・18歳未満は残業できません。\n" },
    { key: "is_work_time_w28", val: "・留学生は週労働時間28時間までです。\n"}
];
